import { render } from "./PreviewImageModal.vue?vue&type=template&id=37815549&scoped=true"
import script from "./PreviewImageModal.vue?vue&type=script&lang=js"
export * from "./PreviewImageModal.vue?vue&type=script&lang=js"

import "./PreviewImageModal.vue?vue&type=style&index=0&id=37815549&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37815549"]])

export default __exports__